'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.initializeMeetingsLibTracker = initializeMeetingsLibTracker;
exports.setTrackerLang = setTrackerLang;
exports.track = track;

var _usageTrackerPublic = require('usage-tracker-public');

var _events = require('MeetingsLib/events.yaml');

var _events2 = _interopRequireDefault(_events);

var _strings = require('MeetingsBase/constants/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_LOCALE = 'en';

var tracker = null;
var screen = 'public';

function initializeMeetingsLibTracker(email, portalId, embedded) {
  screen = embedded ? 'public:embedded' : 'public';
  tracker = (0, _usageTrackerPublic.createTracker)({
    events: _events2.default,
    properties: {
      namespace: _strings.MEETINGS_APP_NAME,
      email: email,
      hubId: portalId,
      lang: window.I18n ? window.I18n.locale : DEFAULT_LOCALE,
      screen: screen
    }
  });
  return tracker;
}

function setTrackerLang(activeLocale) {
  if (tracker) {
    tracker.setProperties({
      lang: activeLocale
    });
  }
}

function track(eventKey) {
  var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (tracker) {
    tracker.track(eventKey, _extends({ screen: screen }, eventProperties));
  }
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/tracking/UsageTracker.js
// module id = 60
// module chunks = 0